import { persistor } from 'redux/store';
import {
  useFirebase,
  useFirebaseActions,
  useADActions,
} from '../services/auth/firebase/FirebaseAuthProvider';
import { getUserFromFirebase } from './helper/AuthHelper';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { useCallback } from 'react';

export const useAuthUser = () => {
  const { isLoading, isAuthenticated, user } = useFirebase();
  const { instance } = useMsal();
  const isAuthenticatedAzure = useIsAuthenticated();
  const userFirebase = getUserFromFirebase(user) ?? {};
  const userAzure = instance.getActiveAccount() ?? {};

  const isAzurePermission = !process.env.REACT_APP_AZURE_GROUP_ID
    ? true
    : userAzure?.idTokenClaims?.groups
    ? userAzure.idTokenClaims.groups.includes(
        process.env.REACT_APP_AZURE_GROUP_ID,
      )
    : false;

  return {
    isLoading,
    isAuthenticated: isAuthenticatedAzure || isAuthenticated,
    user: isAuthenticatedAzure ? userAzure : userFirebase,
    isAzure: isAuthenticatedAzure,
    isAzurePermission: isAzurePermission,
  };
};

export const useAuthMethod = () => {
  const {
    registerUserWithEmailAndPassword,
    logInWithPopup,
    logInWithRedirect,
    logout: logoutAD,
  } = useADActions();
  const { logInWithEmailAndPassword, logout: logoutFirebase } =
    useFirebaseActions();

  const logout = useCallback(() => {
    persistor.purge();
    logoutAD();
  }, [logoutAD]);

  return {
    logInWithEmailAndPassword,
    registerUserWithEmailAndPassword,
    logInWithPopup,
    logInWithRedirect,
    logoutAD,
    logoutFirebase,
    logout: logout,
  };
};
